import { render, staticRenderFns } from "./GroupOfUsers.vue?vue&type=template&id=6b5e39f8"
import script from "./GroupOfUsers.vue?vue&type=script&lang=js"
export * from "./GroupOfUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports